import reactionTypes from '../constants/ResourceReactionActionTypes';
import voteTypes from '../constants/VoteActionTypes';
import { createReaction, createVote, deleteReaction, deleteVote } from './utils';

const initialState = {
  status: { fetch: {} },
  items: {},
};

export default function onlineCourseQuestions(state = initialState, action) {
  switch (action.type) {
    case reactionTypes.CREATE_RESOURCE_REACTION_SUCCESS: {
      return createReaction('OnlineCourseQuestion', action, state);
    }
    case reactionTypes.DELETE_RESOURCE_REACTION_SUCCESS: {
      return deleteReaction('OnlineCourseQuestion', action, state);
    }

    case voteTypes.CREATE_VOTE_SUCCESS:
      return createVote('OnlineCourseQuestion', action, state);

    case voteTypes.DELETE_VOTE_SUCCESS:
      return deleteVote('OnlineCourseQuestion', action, state);

    default:
      return state;
  }
}
